import { registerSW } from 'virtual:pwa-register';

const unregisterDevelopmentServiceWorkers = async () => {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }
};

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;

  if (import.meta.env.DEV) {
    unregisterDevelopmentServiceWorkers().catch((error) => {
      console.warn('Failed to clear development service worker cache', error);
    });
    return;
  }

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type !== 'APP_SHELL_UPDATED') return;

    const currentBuild = sessionStorage.getItem('fairmont-app-shell-build');
    if (currentBuild === event.data.buildId) return;

    sessionStorage.setItem('fairmont-app-shell-build', event.data.buildId);
    window.location.reload();
  });

  const refreshToLatestAppShell = async (updateSW: (reloadPage?: boolean) => Promise<void>) => {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
      }
      await updateSW(true);
    } catch (error) {
      console.warn('Failed to activate the latest app shell', error);
    }
  };

  const updateSW = registerSW({
    immediate: true,
    onRegisteredSW(swUrl) {
      console.info(`Field PWA service worker registered: ${swUrl}`);
    },
    onNeedRefresh() {
      void refreshToLatestAppShell(updateSW);
    },
    onOfflineReady() {
      void updateSW();
    },
    onRegisterError(error) {
      console.error('Field PWA service worker registration failed', error);
    },
  });
};
